import { Injectable } from '@angular/core';
import {SpinnerComponent} from './spinner.component';

@Injectable()
export class SpinnerService {
  private spinnerCache = new Set<SpinnerComponent>();
  constructor() { }

  _register(spinner: SpinnerComponent): void{
    this.spinnerCache.add(spinner);
  }

  _unregister(spinner: SpinnerComponent): void{
    this.spinnerCache.forEach(
      s => {
        if (s === spinner) {
          this.spinnerCache.delete(s);
        }
      });
    }

  show(spinnerName: string): void{
    this.spinnerCache.forEach(
      spinner => {
      if (spinner.name === spinnerName) {
        spinner.show = true;
      }
    });
  }

  hide(spinnerName: string): void{
    this.spinnerCache.forEach(
      spinner => {
        if (spinner.name === spinnerName) {
          spinner.show = false;
        }
      });
    }

  showGroup(groupName: string): void{
    this.spinnerCache.forEach(
      spinner => {
        if (spinner.groupname === groupName) {
          spinner.show = true;
        }
      });
    }

  hideGroup(groupName: string): void{
    this.spinnerCache.forEach(
    spinner => {
      if (spinner.groupname === groupName) {
        spinner.show = false;
      }
    });
  }

  hideAll(): void{
    this.spinnerCache.forEach(
      spinner =>  spinner.show = false);
  }

  showAll(): void{
    this.spinnerCache.forEach(
      spinner =>  spinner.show = true) ;
  }

  isShowing(spinnerName: string): boolean | undefined{
    let isShowing;
    this.spinnerCache.forEach(
    spinner => {
      if (spinner.name === spinnerName) {
        isShowing = spinner.show;
      }
    });

    return isShowing;
  }
}
